import { useParams } from 'react-router-dom';
import allProducts from '../allProducts';
import getDetails from '../getDetails';
import { useState } from 'react';

function ProductPage(){
    const { category } = useParams();
    console.log(category)
    let [ showDetails, setShowDetails ] = useState(false);
    let [details, setDetails] = useState({});
    function handleShowDetails(product_id){
        setShowDetails(() => true);
        setDetails(getDetails(product_id));
        return details;
    }
    return (<div className="container">
        <div id="brand-list">
            <h2 className="section-title">{allProducts[category].label}</h2>
            <p className="section-subtitle">BRANDS</p>

            <div className={"brands-container" + (!showDetails ? "" : " hidden")}>
                {allProducts[category].products.map(product => {
                    return (<div key={product.product_id} className="brand-card" onClick={() => handleShowDetails(product.product_id)}>
                        <div className="brand-button">
                            <span className="icon">&#10145;</span>
                            <span className="brand-name">{product.name}</span>
                        </div>
                    </div>);
                })}
                
            </div>
        </div>

        <div id="product-details" className={showDetails ? "" : "hidden"}>
            <div className="product-content">
                <button className="back-button" onClick={() => setShowDetails(false)}>&#8592; Back</button>
                <img id="product-image" src={"/product-images/" + details.image} alt="Image missing"/>
                <div className="product-text">
                    <h2>{allProducts[category].label}</h2>
                    <h3 id="product-name">{details.name}</h3>
                    <p id="product-description">{details.description}</p>
                    <button className="enquiry-button">Enquiry</button>
                </div>
            </div>
        </div>
    </div>)
}

export default ProductPage;